<template>
  <div class="main">
    <!-- <back title="绵阳欧米奇"></back> -->
    <van-nav-bar
      title="绵阳欧米奇西点职业技能学校"
      left-text="首页"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="banner">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item>
         <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
            <van-image
              src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/chatpage/banner1.jpg"
            />
          </a>
        </van-swipe-item>
        <van-swipe-item>
         <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
            <van-image
              src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/chatpage/banner2.jpg"
            />
          </a>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="button">
      <Button type="warning" style="width:47%;margin:0 2%;font-size:16px;" to="chat">初高中起点专科</Button>
      <Button type="warning" style="width:47%;font-size:16px;" to="chat" ghost>初高中起点本科</Button>
    </div>

    <div class="part1">
     <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
        <van-image
          src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/chatpage/part1.jpg"
        />
      </a>
    </div>
    <div class="part2">
      <Button type="error" color="red" to="chat">初高中毕业学什么好</Button>
      <Button type="error" color="red" to="chat">绵阳高就业专业排名</Button>
      <Button type="error" color="red" to="chat">学费多少钱</Button>
      <Button type="error" color="red" to="chat" style="font-size:14px">初高中毕业能上的学校</Button>
      <Button type="error" color="red" to="chat">职校招生简章</Button>
      <Button type="error " color="red" to="chat">职校有哪些专业</Button>
    </div>
   <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/chatpage/chatlist.gif"
      />
    </a>
  </div>
</template>

<script>
export default {
  components: {
    back: () => import("@/components/head/back")
  },
  methods:{
      onClickLeft(){
          this.$router.push('/')
      }
  }
};
</script>

<style lang="less" scoped>
/deep/ .van-nav-bar .van-icon{
    color:#fff;
}
/deep/ .van-nav-bar__text{
    color:#fff
}
/deep/ .van-nav-bar__title{
    color:#fff;
}
/deep/ .van-nav-bar{
    background-color: #aa6b01;
}

/deep/ .ivu-btn-error {
  border-color: #ed4014;
  width: 48%;
  margin-right: 2%;
  font-size: 16px;
  margin-bottom: 10px;
}
.part2 {
  padding: 0 10px;
}
.part1 {
  width: 100%;
  padding: 10px 0;
}
.button {
  width: 100%;
  padding: 5px 0;
}

.line {
  width: 2%;
  height: 50px;
  float: left;
}
.input {
  width: 60%;
  height: 37px;
  background: #fff;
  margin-top: 3px;
  float: left;
  border: 1px solid #fff;
  border-radius: 4px;
}
.fitimg {
  width: 100%;
  height: 100%;
}
.foot {
  width: 100%;
  height: 50px;
  padding: 5px;
  background: #eee;
  position: fixed;
  bottom: 0;
  border-top: 1px solid #9e9e9e;
}
.foot-icon {
  width: 40px;
  height: 40px;
  float: left;
}
</style>